import { Component, Vue } from 'vue-property-decorator'

@Component({ name: 'GtrSecurityLayout' })
export default class GrtSecurityLayout extends Vue {
  get isFamiliarUiLogin (): boolean {
    return process.env.VUE_APP_FAMILIAR_UI_LOGIN === '1'
  }

  mounted () {
    if (this.isFamiliarUiLogin) {
      const LINK_ID = 'familiar-ui-inter-font'
      if (!document.getElementById(LINK_ID)) {
        const link = document.createElement('link')
        link.id = LINK_ID
        link.rel = 'stylesheet'
        link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap'
        document.head.appendChild(link)
      }
    }
  }
}
